import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/loans/$id/pdf")({
  component: LoanPdfPage,
});

function LoanPdfPage() {
  return (
    <section>
      <h1 className="text-xl font-semibold">PDF preview</h1>
      <p className="mt-2 text-sm text-white/60">Borrower PDF lands in Plan E.</p>
    </section>
  );
}
